import * as React from 'react';
import Container from '@mui/material/Container';
import ImageList from '@mui/material/ImageList';
import Link from '@mui/material/Link';

import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import GalleryImage, { GalleryImageProps } from './GalleryImage.tsx';
import { Typography } from '@mui/material';

export type ImageGalleryGridProps = {
  images: GalleryImageProps[]
};


export default function ImageGalleryGrid(props: ImageGalleryGridProps) {
  const [openedImage, setOpenedImage] = React.useState<any>(null);
  const closeDialog = () => {
    setOpenedImage(null);
  };

  const openDialog = (image: GalleryImageProps) => {
    return () => {
      setOpenedImage(image);
    };
  };

  const dialogMaxWidth = (openedImage !== null && !openedImage.lowRes) ? "xl" : "sm";

  return (
    <Container sx={{
      px: 0,
      minWidth: "300",
      width: "100%",
      display: 'flex',
    }}>
      <ImageList
        variant="quilted"
        cols={4}
        sx={{width:"100%", px: 0}}
      >
        {props.images.map((item) => (
          <GalleryImage 
            src={item.src} 
            title={item.title} 
            rows={item.rows} 
            cols={item.cols}
            onClick={openDialog(item)}
          />
      ))}
      </ImageList>
      <Dialog onClose={closeDialog} 
      fullWidth
      maxWidth={dialogMaxWidth}
      scroll='body'
      open={openedImage !== null}>
        <IconButton
          aria-label="close"
          onClick={closeDialog}
          sx={(theme) => ({
            position: 'absolute',
            right: 1,
            top: 1,
            color: theme.palette.grey[900],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <img src={openedImage ? openedImage.src : null} 
            alt={openedImage ? openedImage.title : null} 
            style={{
            display: 'flex',
            width: "100%",
            paddingTop: "1rem"
          }} />
          <Typography component="div" sx={{width: "100%", textAlign: "center", pt: 1}} variant='h6'>{openedImage ? openedImage.title : ""}</Typography>
        </DialogContent>
      </Dialog>
    </Container>
  );
}
